import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'
import styles2 from './../style/NalichnikiOtzivi.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class NalichnikiOtzivi extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section} ${styles.top}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              className={styles.title}
            />
          }
          <div className={`${styles.list} ${styles[`grid-3`]}`}>
            {list.map( ( elm, k ) => {
              if(elm?.image == '') return (
                <div className={`${styles.block} ${styles[`bg-2`]}`}>
                  <div className={styles2.cardtitle} dangerouslySetInnerHTML={{__html: elm?.title}} />
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.subtitle}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
              return (
                <div className={`${styles.block} ${styles2.card}`}>
                  <Image className={styles2.bgimage} src={elm?.image} alt={`Заказать консультацию`} width={386} height={285} />
                  <div className={styles2.card_content}>
                    <div className={styles2.b_title}>
                      <div className={styles2.b_title_t} dangerouslySetInnerHTML={{__html: elm?.subtitle}} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <GreenButton
                      text={`Заказать консультацию`}
                      width={200}
                      action={() => this.showFeedback()}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </Container>
        <FeedbackForm
          title={`Заказать консультацию`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

NalichnikiOtzivi.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string
}

NalichnikiOtzivi.defaultProps = {
  list: [],
  title: ``
}

export default NalichnikiOtzivi